module.exports = __webpack_public_path__ + "static/img/6.80037767.png";